import React, { useMemo, useState, useRef } from "react"
import ReactDOM from "react-dom"
import AnimateHeight from "react-animate-height"
import { useSelect } from "downshift"
import { useMeasure } from "../../util/useMeasure"
import {
  SelectedOption,
  Expanded,
  Collapsed,
  Option,
  ExpandIcon,
  CollapseIcon,
  normalizeItem,
} from "./common"

export const LiveDropDown = props => {
  const ref = useRef()
  const {
    items,
    type,
    size,
    placeholder,
    className,
    style,
    value,
    onChange,
    renderOption,
  } = props
  const [expandedVisible, setExpandedVisible] = useState(false)

  const normalizedItems = useMemo(() => {
    return items.map(normalizeItem)
  }, [items])

  const selectedItem = useMemo(() => {
    return normalizedItems.find(item => {
      if (value && value.value) {
        return item.value === value.value
      }
      return item.value === value
    })
  }, [value, normalizedItems])

  const {
    isOpen,
    getToggleButtonProps,
    getMenuProps,
    highlightedIndex,
    getItemProps,
  } = useSelect({
    items: normalizedItems,
    selectedItem,
    onSelectedItemChange: onChange,
  })

  const bbox = useMeasure({ windowResize: true, ref })

  const expandedStyle = useMemo(() => {
    const bbox = ref.current?.getBoundingClientRect()
    return {
      ...style,
      visibility: expandedVisible ? "visible" : "hidden",
      left: bbox?.left,
      top: bbox?.top,
      width: bbox?.width,
    }
  }, [expandedVisible, style])

  const handleAnimationStart = () => {
    if (isOpen) {
      setExpandedVisible(true)
    }
  }

  const handleAnimationEnd = () => {
    if (!isOpen) {
      setExpandedVisible(false);
    }
  }

  return (
    <>
      <Collapsed
        type="button"
        {...getToggleButtonProps({ ref })}
        $size={size}
        $type={type}
        className={className}
        style={style}
      >
        <SelectedOption $type={type.type} $size={size} selected={selectedItem}>
          {renderOption({ children: selectedItem?.label || placeholder, selected: true })}
        </SelectedOption>
        <ExpandIcon />
      </Collapsed>
      {ReactDOM.createPortal(
        <Expanded
          {...getMenuProps()}
          style={expandedStyle}
          isOpen={isOpen}
          $type={type}
          size={size}
        >
          <AnimateHeight
            id="example-panel"
            onAnimationStart={handleAnimationStart}
            onAnimationEnd={handleAnimationEnd}
            height={isOpen && bbox.height ? "auto" : bbox?.height || 0}
          >
            {normalizedItems.map((item, index) => (
              <Option
                $selected={item === selectedItem}
                $highlighted={highlightedIndex === index}
                key={`${item.value}${index}`}
                {...getItemProps({ item, index, disabled: item.disabled })}
              >
                { renderOption({ children: item.label, selected: item === selectedItem, disabled: item.disabled }) }
                {index === 0 && (<CollapseIcon className="absolute right-0" {...getToggleButtonProps()} />)}
              </Option>
            ))}
          </AnimateHeight>
        </Expanded>,
        document.body
      )}
    </>
  )
}

LiveDropDown.propTypes = {

}

LiveDropDown.defaultProps = {
  type: "primary-outline",
}
